const API_URL = "/api";

// Health check
export const checkHealth = async () => {
  try {
   

    // Add timeout and no-cache headers
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000); // 5 second timeout

    const response = await fetch(`${API_URL}/health`, {
      method: "GET",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
      },
      signal: controller.signal,
    });

    clearTimeout(timeoutId);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Backend health check FAILED:", error.message);
    return {
      status: "unhealthy",
      error: error.message,
      timestamp: new Date().toISOString(),
    };
  }
};
// Get all competitions
export const getCompetitions = async () => {
  try {
    const response = await fetch(`${API_URL}/competitions`);
    if (!response.ok) throw new Error("Failed to fetch");
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error:", error);
    return { success: false, competitions: [] };
  }
};

// Create team
export const createTeam = async (teamData) => {
  try {
    const response = await fetch(`${API_URL}/teams/create`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(teamData),
    });
    return await response.json();
  } catch (error) {
    console.error("Error:", error);
    return { success: false, message: "Network error" };
  }
};

// Join team
export const joinTeam = async (teamToken, userId) => {
  try {
    const response = await fetch(`${API_URL}/teams/join`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ teamToken, userId }),
    });
    return await response.json();
  } catch (error) {
    console.error("Error:", error);
    return { success: false, message: "Network error" };
  }
};

// Get team by token
export const getTeamByToken = async (teamToken) => {
  try {
    const response = await fetch(`${API_URL}/teams/${teamToken}`);
    return await response.json();
  } catch (error) {
    console.error("Error:", error);
    return { success: false, message: "Server error" };
  }
};

// Export all functions
export default {
  checkHealth,
  getCompetitions,
  createTeam,
  joinTeam,
  getTeamByToken,
};
